export function renamespaceValue(value: string, namespaceMap: {[key: string]: string}) {
  return Object.entries(namespaceMap).reduce((acc, [matchKey, replaceString]) => {
    if (acc.startsWith(matchKey)) {
      const matchRegex = new RegExp(`^${matchKey}`);
      acc = acc.replace(matchRegex, replaceString);
    }
    return acc;
  }, value || '');
}


export function renamespaceKeys(entry: { [key: string]: any}, namespaceMap: {[key: string]: string}) {
  // Iterate through key value pairs
  return Object.entries(entry)
    .reduce((result, [sourceKey, sourceValue]) => {
      const newKey = renamespaceValue(sourceKey, namespaceMap);
      result[newKey] = sourceValue;
      return result;
    }, {});
}
